export const GridEnum = {
  INV_Item_View: 'INV_Item_View',
  INV_BidPrice_View: 'INV_BidPrice_View',
  INV_ItemDetail_View: 'INV_ItemDetail_View',
  INV_FIFO_View: 'INV_FIFO_View',
  INV_TransactionDetails_View: 'INV_TransactionDetails_View',
  INV_ManageProcessOrder_View: 'INV_ManageProcessOrder_View',
  INV_ManageProcessOrder_CreateEdit_OrderItems_View:
    'INV_ManageProcessOrder_CreateEdit_OrderItems_View',
  INV_ManageProcessOrder_CreateEdit_SiteItems_View:
    'INV_ManageProcessOrder_CreateEdit_SiteItems_View',
  INV_ManagePurchaseOrder_View: 'INV_ManagePurchaseOrder_View',
  INV_TransferOrder_View: 'INV_TransferOrder_View',
  INV_TransferOrder_CreateEdit_View: 'INV_TransferOrder_CreateEdit_View',
  INV_ManagePurchaseOrder_CreateEdit_OrderItems_View:
    'INV_ManagePurchaseOrder_CreateEdit_OrderItems_View',
  INV_ManagePurchaseOrder_CreateEdit_SiteItems_View:
    'INV_ManagePurchaseOrder_CreateEdit_SiteItems_View',
  INV_CreateEditReceiveInventory_View: 'INV_CreateEditReceiveInventory_View',
  INV_UsageList_View: 'INV_UsageList_View',
  INV_UsageList_CreateEdit_View: 'INV_UsageList_CreateEdit_View',
  INV_Physical_View: 'INV_Physical_View',
  INV_Physical_CreateEdit_View: 'INV_Physical_CreateEdit_View',
  INV_AdjustmentList_View: 'INV_AdjustmentList_View',
  INV_AdjustmentList_CreateEdit_View: 'INV_AdjustmentList_CreateEdit_View',
  INV_AdjustmentList_Edit_View: 'INV_AdjustmentList_Edit_View',
  INV_Custom_Query_View: 'INV_Custom_Query_View',

  INV_OnHandReport_FIFO_View: 'INV_OnHandReport_FIFO_View',
  INV_OnHandReport_TransactionDetails_View:
    'INV_OnHandReport_TransactionDetails_View',
  INV_OnHandReport_Listing_View: 'INV_OnHandReport_Listing_View',
  INV_AssignEntities_Item_View: 'INV_AssignEntities_Item_View',

  MNU_Manage_Recipe_View: 'MNU_Manage_Recipe_View',
  MNU_Ingredient_Table_View: 'MNU_Ingredient_Table_View',

  CK_Kitchen_Prep_Worksheet_View: 'CK_Kitchen_Prep_Worksheet_View',
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/GridEnum.js